export const Pill: React.FC<{
  children: React.ReactNode;
  color?: "green" | "blue" | "purple" | "amber" | "gray";
}> = ({ children, color = "gray" }) => {
  const colors: Record<string, string> = {
    green: "bg-primary-50/20 text-primary-700 border-primary-100",
    blue: "bg-blue-50/20 text-blue-700 border-blue-200",
    purple: "bg-violet-50/20 text-violet-700 border-violet-200",
    amber: "bg-amber-50/20 text-amber-700 border-amber-200",
    gray: "bg-gray-100/20 text-gray-600 border-gray-200",
  };
  return (
    <span
      className={`inline-flex items-center text-[11px] font-medium px-2 py-0.5 rounded-full border ${colors[color]}`}
    >
      {children}
    </span>
  );
};
